import React, { Suspense, lazy, useEffect } from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../_metronic/layout";
import AllDashboardPages from "./pages/dashboard";
import ReportPages from "./pages/reports";
import { useSelector } from "react-redux";

const UserPage = React.lazy(() => import("./pages/users"));
const ProfilePage = React.lazy(() => import("./pages/profile"));
const AdminSetting = React.lazy(() => import("./pages/admin-setting"));
const Setting = React.lazy(() => import("./pages/setting"));
const WholesalePage = React.lazy(() => import("./pages/wholesale"));
const CustomerPage = React.lazy(() => import("./pages/customer"));
const DeliveryPage = React.lazy(() => import("./pages/delivery"));
const BulkPurchase = React.lazy(() => import("./pages/bulk-purchase"));
const OrdersPage = React.lazy(() => import("./pages/orders"));
const RecipesPage = React.lazy(() => import("./pages/recipes"));
const ProductsPage = React.lazy(() => import("./pages/products"));
const PromotionsPage = React.lazy(() => import("./pages/promotions"));
const fabricationCookingAdd = React.lazy(() => import("./pages/b2b"));
const Notifications = React.lazy(() => import("./pages/notifications"));
const GpsMotoTracker = React.lazy(() => import("./pages/gps-moto-tracker"));
const PromotionModulePage = React.lazy(() =>
  import("./pages/promotion-module")
);

export default function BasePage() {
  const userRole = JSON.parse(localStorage.getItem("user")).data.userRoleId;
  // console.log(userRole);

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {/* {<Redirect exact from="/" to="/dashboard" />} */}
        {userRole == 1 || userRole == 19 ? (
          <Redirect exact from="/" to="/dashboard" />
        ) : (
          <Redirect exact from="/" to="/orders/orders-historyb2c" />
        )}

        <Route path="/dashboard" component={AllDashboardPages} />
        <Route path="/users" component={UserPage} />
        <Route path="/profile" component={ProfilePage} />
        <Route path="/user-setting" component={Setting} />
        <Route path="/admin-setting" component={AdminSetting} />
        <Route path="/wholesale" component={WholesalePage} />
        <Route path="/bulk-purchase" component={BulkPurchase} />
        <Route path="/customer" component={CustomerPage} />
        <Route path="/delivery-process" component={DeliveryPage} />
        <Route path="/orders" component={OrdersPage} />
        <Route path="/recipes" component={RecipesPage} />
        <Route path="/products" component={ProductsPage} />
        <Route path="/promotions" component={PromotionsPage} />
        <Route path="/promotion" component={PromotionModulePage} />
        <Route path="/btob" component={fabricationCookingAdd} />
        <Route path="/report" component={ReportPages} />
        <Route path="/notifications" component={Notifications} />
        <Route path="/gps-moto-tracker" component={GpsMotoTracker} />

        {/* <Redirect to="error/error-v1" /> */}
      </Switch>
    </Suspense>
  );
}
